
export {FirstDayOfWeek} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$date-picker.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$date-picker.js';export default __x__;